import {
    call, put, all, takeLatest, spawn, select,
} from 'redux-saga/effects';
import Api from '../services/ApiManager';
import notification from '../../helpers/notification';
import { deleteEntityAction, saveEntityAction } from '../actions/entityActions';
import { EntityActionTypes, saveEntityActionType, deleteEntityActionType } from '../../model/entity/action';
import { execSaveRequest, Options } from './effects';

function* saveEntity(action: EntityActionTypes) {
    const options: Options = {
        payload: action.payload,
        successMessage: 'Entité sauvegardée avec succès'
    };
    yield call(execSaveRequest,
        Api.entities.create,
        Api.entities.update,
        saveEntityAction.success,
        saveEntityAction.failure,
        options);
}

function* deleteEntity(action: EntityActionTypes) {
    try {
        const botId = yield select(state => state.bot.selectedBot);
        yield call(Api.entities.delete, botId, action.payload as string);
        yield put(deleteEntityAction.success(action.payload as string));
        notification.sucess('Entité sauvegardée avec succès');
    } catch (error) {
        yield put(deleteEntityAction.failure());
        notification.error(
            'Une erreur est survenue, veuillez réessayez ultérieurement',
        );
    }
}

export function* startEntitiesSagas() {
    yield all([
        takeLatest(saveEntityActionType.request, saveEntity),
        takeLatest(deleteEntityActionType.request, deleteEntity),
    ]);
}